import { FileDashboardMultiViewModel } from '@fora-monorepo/employer-my-pages-common/types';

export const mockFileDashboardMulti: FileDashboardMultiViewModel = {
  fileReportHistoryLog: [
    {
      partnerNumberOrganization: '8000096879',
      organizationName: 'Tosca Test Organization 85814',
      organizationNumber: '8806228345',
      adminReporterFullName: '',
      fileName: '',
      reportedAt: '2024-06-10T15:19:25.514Z',
    },
    {
      partnerNumberOrganization: '0030023349',
      organizationName: 'AVICON AB',
      organizationNumber: '5566383906',
      adminReporterFullName: 'Rebecca Test',
      fileName: '',
      reportedAt: '2024-06-10T08:55:57.243Z',
    },
  ],
  openReportingPeriods: [
    {
      payMonth: '202406',
      periodFromDate: '2024-06-01',
      periodToDate: '2024-07-31',
      isPeriodOpen: true,
    },
    {
      payMonth: '202407',
      periodFromDate: '2024-07-01',
      periodToDate: '2024-08-31',
      isPeriodOpen: true,
    },
  ],
};
